"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PageSection;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cta = _interopRequireDefault(require("../cta/cta"));
var _pageSectionModule = _interopRequireDefault(require("./pageSection.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function PageSection(props) {
  var id = props.id,
    className = props.className,
    innerContainerClassName = props.innerContainerClassName,
    backgroundColour = props.backgroundColour,
    textColour = props.textColour,
    title = props.title,
    copy = props.copy,
    eyebrow = props.eyebrow,
    children = props.children,
    spacingAbove = props.spacingAbove,
    spacingBelow = props.spacingBelow;
  var sectionStyle = {
    '--backgroundColour': backgroundColour,
    '--textColour': textColour
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
    className: (0, _classnames["default"])(_pageSectionModule["default"].pageSection, className),
    style: sectionStyle,
    "data-testid": props['data-testid'],
    "data-section": title,
    id: id,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames["default"])(_pageSectionModule["default"].innerContainer, innerContainerClassName, _defineProperty(_defineProperty({}, _pageSectionModule["default"]["spacingAbove_".concat(spacingAbove)], spacingAbove), _pageSectionModule["default"]["spacingBelow_".concat(spacingBelow)], spacingBelow)),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _pageSectionModule["default"].text,
        children: [eyebrow && /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: _pageSectionModule["default"].eyebrow,
          children: eyebrow
        }), title && /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          className: _pageSectionModule["default"].title,
          children: title
        }), copy && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _pageSectionModule["default"].copy,
          children: copy
        })]
      }), children, props.cta && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _pageSectionModule["default"].ctaWrapper,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_cta["default"], {
          type: props.cta.type,
          label: props.cta.label,
          target: props.cta.target
        })
      })]
    })
  });
}